/* eslint-disable camelcase */
// import sample from '@sample/account/users.json'
import axios from '@axios'


export const state = {
    productList: [],
    subscriptions: [],
}

export const getters = {
    allProducts: (state) => state.productList,
    allUserSubscriptions: (state) => state.subscriptions
}

export const mutations = {
    GET_PRODUCTS_LIST: (state, products) => {
        if (!products.products) return false
        state.productList = products.products
    },
    GET_USER_SUBSCRIPTION: (state, products) => {
        if (!products) return false
        products.subscriptions.sort(function (a, b) {
            return a.id - b.id;
        })
        state.subscriptions = products.subscriptions
    },
    SUBSCRIBE_PRODUCT: (state, products) => {
        if (!products) return false
        state.subscriptions = products.subscription
    },
    UNSUBSCRIBE_PRODUCT: (state, products) => {
        if (!products) return false
        state.subscriptions.forEach((element, index) => {
            if (element.id === products) {
                state.subscriptions.splice(index, 1);
            }
        });
    }
}

export const actions = {
    async getProductLists({ commit, dispatch }) {
        dispatch('layout/changeLoading', true, { root: true })
        return axios.get(`/products`)
            .then((resp) => {
                if (resp.status === 200) {
                    commit('GET_PRODUCTS_LIST', resp.data)
                    dispatch('layout/changeLoading', false, { root: true })
                }
            })
            .catch(() => {
                dispatch('layout/changeLoading', false, { root: true })
            })
            .finally(() => {
                dispatch('layout/changeLoading', false, { root: true })
            })
    },
    async getUserSubscription({ commit, dispatch }) {
        dispatch('layout/changeLoading', true, { root: true })
        return axios.get(`/users/product/subscriptions`)
            .then((resp) => {
                if (resp.status === 200) {
                    commit('GET_USER_SUBSCRIPTION', resp.data)
                    dispatch('layout/changeLoading', false, { root: true })
                }
            })
            .catch(() => {
                dispatch('layout/changeLoading', false, { root: true })
            })
            .finally(() => {
                dispatch('layout/changeLoading', false, { root: true })
            })

    },
    async subscribeProduct({ commit, dispatch }, id) {
        dispatch('layout/changeLoading', true, { root: true })
        return axios.post(`/products/${id}/subscribe`)
            .then((resp) => {
                if (resp.status === 200) {
                    commit('SUBSCRIBE_PRODUCT', resp.data)
                    commit('auth/UPDATE_SUBSCRIBE', resp.data, { root: true })
                    dispatch('layout/changeLoading', false, { root: true })
                    let notification = {
                        id: Date.now(),
                        message: 'You need to refresh the page after subscribe.',
                        type: 'info',
                        title: 'Subscribe',
                    }
                    dispatch('notification/addNotification', notification, {
                        root: true,
                    })
                } else {
                    let notification = {
                        id: Date.now(),
                        message: 'Failed to subscribe product.',
                        type: 'error',
                        title: 'Subscribe',
                    }
                    this.$store.dispatch('notification/addNotification', notification, {
                        root: true,
                    })
                }
            })
            .catch(() => {
                let notification = {
                    id: Date.now(),
                    message: 'Failed to subscribe product.',
                    type: 'error',
                    title: 'Subscribe',
                }
                this.$store.dispatch('notification/addNotification', notification, {
                    root: true,
                })
                dispatch('layout/changeLoading', false, { root: true })
            })
            .finally(() => {
                dispatch('layout/changeLoading', false, { root: true })
            })

    },
    async unsubscribeProduct({ dispatch, commit, state }, id) {
        dispatch('layout/changeLoading', true, { root: true })
        return axios.post(`/products/${id}/unsubscribe`)
            .then((resp) => {
                if (resp.status === 200) {
                    let notification = {
                        id: Date.now(),
                        message: 'You need to refresh the page after unsubscribe.',
                        type: 'info',
                        title: 'Unsubscribe',
                    }
                    dispatch('notification/addNotification', notification, {
                        root: true,
                    })


                    commit('UNSUBSCRIBE_PRODUCT', id)
                    commit('auth/UPDATE_SUBSCRIBE', resp.data, { root: true })
                    dispatch('layout/changeLoading', false, { root: true })
                }
            })
            .catch(() => {
                dispatch('layout/changeLoading', false, { root: true })
            })
            .finally(() => {
                dispatch('layout/changeLoading', false, { root: true })
            })

    }
}

